import { useCallback, useMemo } from "react"
import { Avatar, Box, Chip, Typography, useTheme } from "@mui/material"
import { useNavigate } from "react-router-dom"
import { useTranslation } from "providers/i18n"
import { CustomIcon } from "components/icons"
import { getFeatureDetail } from "utils/feature"
import _ from "lodash"

import { FeatureListItem } from "components/domains/features"
import { ShopIcon } from "../../icons"
import { useVenue } from "providers/venue"

export const ShopListItem = ({ occupant, hideLevel = false, ...props }) => {
  const { t } = useTranslation({ defaultValue: null })
  const { isMultiVenueProject } = useVenue()
  const navigate = useNavigate()
  const {
    name,
    logo,
    level,
    zone,
    venueLogo,
    category,
    categoryIcon,
    venueName,
  } = useMemo(() => getFeatureDetail(occupant), [occupant])

  const categoryText = useMemo(() => t(category), [category, t])
  const venueText = useMemo(() => t(venueName)?.toUpperCase(), [venueName, t])
  const levelText = !hideLevel && level && `${t(level)}`
  const zoneText = zone && `${t("Zone")} ${t(zone)}`

  const secondaryText = useMemo(
    () =>
      _.compact([
        _.compact([t(venueText), levelText]).join(" - "),
        zoneText || categoryText,
      ]).join(" | "),
    [levelText, t, venueText, zoneText, categoryText]
  )

  const handleClick = useCallback(
    () => navigate(`/maps/place/${occupant.id}`),
    [navigate, occupant?.id]
  )

  const isSection = occupant?.feature_type === "section"

  const theme = useTheme()
  const { secondaryWrapper, zoneChip } =
    theme.components[`ShopListItem`]?.styleOverrides || {}

  return (
    <FeatureListItem
      divider
      onClick={handleClick}
      primary={t(name)}
      secondary={
        <Box sx={secondaryWrapper}>
          {isSection && (
            <Chip variant="contained" label={t("Zone")} sx={zoneChip} />
          )}
          <Typography variant="subtitle1" className="MuiListItemText-secondary">
            {secondaryText}
          </Typography>
        </Box>
      }
      avatar={
        <Avatar src={logo} variant="logo">
          {!logo &&
            (categoryIcon ? <CustomIcon path={categoryIcon} /> : <ShopIcon />)}
        </Avatar>
      }
      endAdornment={isMultiVenueProject && venueLogo}
      {...props}
    />
  )
}

export default ShopListItem
